import styled, { css } from 'styled-components';
import { TAG_STYLES } from '@common/components/tag/tag.styled';

const SPACER = 3;

const FORM_FIELD_ERROR_STYLES = css`
  ${TAG_STYLES};
  line-height: 2;

  background-color: rgba(255, 51, 92, 1);
  color: white;
  position: relative;
  top: ${SPACER}px;

  &::before {
    content: '';
    width: ${SPACER * 3}px;
    height: ${SPACER * 3}px;
    position: absolute;
    background-color: rgba(255, 51, 92, 1);
    transform: rotate(-45deg);
    top: -${SPACER}px;
    z-index: -1;
  }
`;

export const FieldErrorMessageSC = styled.div`
  height: ${SPACER * 10}px;

  .error {
    ${FORM_FIELD_ERROR_STYLES}
  }
`;
